import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs/Observable';
import { AppServiceService } from '../app-service.service';

@Injectable()
export class QualityResolve implements Resolve<any> {
    constructor(private api: ApiService, private app: AppServiceService) {
        this.app.menuState.next('hide');
        this.app.submenuState.next('hide');
    }

    resolve(): Observable<any> | Promise<any> | any {
        return this.api.getQuality();
    }
}


// WEBPACK FOOTER //
// ./src/app/resolves/quality.resolve.ts